import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import {Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment'

@Injectable()
export class UserService {

  constructor(private http: HttpClient, public router: Router, private route: ActivatedRoute) { }

  getUser(token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/user/all', {headers});
  }

  getUserByID(id, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/user/' + id, {headers});
  }

  getProfile(token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/user', {headers});
  }
  
  createUser(body, token) {
    // const headers = new HttpHeaders({'Authorization': token});
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post( environment.backend + '/users', body, {headers});
  }

  updateProfile(body, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.put( environment.backend + '/user', body, {headers});
  }

  updateUser(id, body, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.put( environment.backend + '/user/' + id, body, {headers});
  }

  deleteUser(id, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.delete( environment.backend + '/user/' + id, {headers});
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/user.service.ts